import { useAuthStore } from "@/stores/auth";
import { TeamSwitcher } from "./TeamSwitcher";

/** In-page team scope bar.
 *
 * Hosts the {@link TeamSwitcher} on the surfaces that actually depend
 * on the active-scope team — the coaching, feedback, and admin shells.
 * The switcher used to live in the global header, where it rendered
 * on public team pages too and let users coach the wrong team without
 * noticing (the public pages take their team from the URL, not scope).
 *
 * Mirrors `TeamSwitcher`'s own visibility rule so a single-team
 * non-admin user sees no stray `TEAM` label.
 */
export function TeamScopeBar() {
  const me = useAuthStore((s) => s.me);
  const isGlobalAdmin = !!me?.user?.is_global_admin;
  const memberships = me?.teams ?? [];
  const visible = !!me?.user && (memberships.length >= 2 || isGlobalAdmin);

  if (!visible) return null;

  return (
    <div
      className="flex min-w-0 flex-wrap items-center gap-2"
      data-testid="team-scope-bar"
    >
      <span className="shrink-0 font-display uppercase tracking-wider text-[0.6rem] text-ink-muted">
        Team
      </span>
      <TeamSwitcher />
    </div>
  );
}
